module.exports = __webpack_public_path__ + "img/df9b943.webp";